import React, { useState, useEffect } from 'react';
import { Book, Home } from 'lucide-react';
import { supabase } from '../lib/supabase';
import { Database } from '../lib/database.types';
import { useNavigate } from 'react-router-dom';

type Message = Database['public']['Tables']['messages']['Row'];

export default function Word() {
  const [messages, setMessages] = useState<Message[]>([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchMessages();
  }, []);

  async function fetchMessages() {
    try {
      const { data, error } = await supabase
        .from('messages')
        .select('*')
        .order('date', { ascending: false });

      if (error) throw error;
      setMessages(data || []);
    } catch (error) {
      console.error('Erro ao buscar mensagens:', error);
    } finally {
      setLoading(false);
    }
  }

  if (loading) {
    return (
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <p>Carregando mensagens...</p>
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="flex items-center justify-between mb-8">
        <div className="flex items-center gap-3">
          <Book className="h-8 w-8 text-brand-teal" />
          <h1 className="text-3xl font-bold text-brand-teal">Palavra</h1>
        </div>
        <button
          onClick={() => navigate('/')}
          className="flex items-center gap-2 px-4 py-2 bg-brand-teal text-white rounded-lg hover:bg-brand-teal/90 transition-colors"
        >
          <Home className="h-4 w-4" />
          <span>Voltar para Home</span>
        </button>
      </div>

      <div className="grid gap-8">
        <div className="bg-white p-6 rounded-xl shadow-elevation-1">
          <h2 className="text-xl font-semibold text-brand-teal mb-4">Devocional do Dia</h2>
          <div className="prose max-w-none">
            <p className="text-gray-600 mb-4">
              "Porque Deus amou o mundo de tal maneira que deu o seu Filho unigênito, para que todo aquele que nele crê não pereça, mas tenha a vida eterna." - João 3:16
            </p>
            <p className="text-gray-600">
              Reflexão sobre o amor incondicional de Deus e como podemos demonstrar esse amor em nossas vidas diárias.
            </p>
          </div>
        </div>

        <h2 className="text-2xl font-semibold text-brand-teal mt-8 mb-4">Mensagens Recentes</h2>
        <div className="grid gap-6">
          {messages.map((message) => (
            <div key={message.id} className="bg-white p-6 rounded-xl shadow-elevation-1 hover:shadow-elevation-2 transition-shadow">
              <h3 className="text-xl font-semibold text-brand-teal mb-2">{message.title}</h3>
              <div className="text-gray-600 space-y-2">
                <p><strong>Pastor:</strong> {message.pastor}</p>
                <p><strong>Data:</strong> {new Date(message.date).toLocaleDateString('pt-BR')}</p>
                {message.description && <p>{message.description}</p>}
                {message.video_url && (
                  <div>
                    <div className="aspect-video w-full mt-4 rounded-lg overflow-hidden">
                      <iframe
                        src={`https://www.youtube.com/embed/${message.video_url.split('v=')[1]}`}
                        className="w-full h-full"
                        allowFullScreen
                        title={message.title}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))}

          {messages.length === 0 && (
            <div className="text-center py-12 text-gray-500">
              Nenhuma mensagem disponível no momento.
            </div>
          )}
        </div>
      </div>
    </div>
  );
}